import styled from "styled-components"

export const TradingViewContainer = styled.div`
  padding-top: 80px;
  h1 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 32px;
  }
  margin-bottom: 42px;
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`
